import ContentPage from 'ai/components/EntryPoint/ContentPage/ContentPage';
import { withContentPageProps } from 'ai/viewModel/entryPoint/withContentPageProps';

export default withContentPageProps(ContentPage);
